import { focusOutline } from 'shared/assets/styles';
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: 100%;
  min-width: 30rem;

  overflow: hidden;

  & button:focus {
    ${focusOutline};
  }
`;

export const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;

  display: flex;
  flex-direction: column;

  overflow-y: auto;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(3)};

  padding: ${({ theme }) =>
    `${theme.spacing(6)} ${theme.spacing(6)} ${theme.spacing(3)} ${theme.spacing(6)}`};
`;

export const TitleColumn = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Body = styled.div`
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  align-items: center;
  column-gap: ${({ theme }) => theme.spacing(7)};
  row-gap: ${({ theme }) => theme.spacing(2)};

  padding: 0 ${({ theme }) => theme.spacing(6)}
    ${({ theme }) => theme.spacing(6)};
`;

export const Section = styled.div`
  display: contents;
`;

export const Item = styled.div<{ $autoWidthField?: boolean }>`
  display: contents;

  & > :last-child {
    ${({ $autoWidthField }) =>
      $autoWidthField
        ? css`
            justify-self: start;
          `
        : css`
            width: 100%;
          `};
  }
`;

export const Label = styled.label`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  min-width: 0;

  & > svg {
    width: 1.6rem;
    height: 1.6rem;
    min-width: 1.6rem;
    flex-shrink: 0;
  }
`;

export const LabelText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`;

export const Divider = styled.div`
  grid-column: 1 / -1;

  width: 100%;
  height: 1px;
  min-height: 1px;
  background-color: ${({ theme }) => theme.palette.grey[400]};
  margin-top: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const Footer = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: flex-end;

  padding: ${({ theme }) => `${theme.spacing(4)} ${theme.spacing(4)}`};
  border-top: 1px solid ${({ theme }) => theme.palette.grey[400]};
`;
